import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AircraftModel } from '../aircraft-models.types';
import { HttpErrorResponse } from '@angular/common/http';
import { AircraftModelsService } from '../aircraft-models.service';
import { AlertDialogComponent } from '../../dialogs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-aircraft-models-details',
	templateUrl: './aircraft-models-details.component.html',
	styleUrls: ['./aircraft-models-details.component.scss']
})
export class AircraftModelsDetailsComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		private aircraftModelsService: AircraftModelsService,
		public dialog: MatDialog
	) {
		this.id = this.route.snapshot.paramMap.get('id');
		this.form = this.formBuilder.group({
			name: new FormControl(this.aircraftModel.name, [Validators.required]),
			effectiveStart: new FormControl(moment.utc())
		});
		this.dialogConfig = new MatDialogConfig();
	}
	public id: string = '';
	public dates: string[] = [];
	public currentDate: string;
	public form: FormGroup;
	public cancel: boolean = false;
	public saveNew: boolean = false;
	public saveChanges: boolean = false;
	public isDelete: boolean = true;
	public isArchived: boolean = false;
	public aircraftModel: AircraftModel = new AircraftModel();
	public alertDialogRef: MatDialogRef<AlertDialogComponent>;
	public dialogConfig: MatDialogConfig;

	ngOnInit(): void {
		const minDateValue: moment.Moment = moment
			.utc()
			.startOf('month')
			.subtract(1, 'M');
		const maxDateValue: moment.Moment = moment
			.utc()
			.startOf('month')
			.add(12, 'M');
		this.getDates(minDateValue, maxDateValue);

		// id will be 0 if creating a new aircraft model
		if (this.id === '0') {
			this.isDelete = false;
		} else {
			if (this.route.snapshot.url.toString().includes('archived')) {
				this.getArchivedAircraftModel(this.id);
			} else {
				this.getAircraftModel(this.id);
			}
		}
	}

	public getDates(startDate: moment.Moment, endDate: moment.Moment): string[] {
		const now: moment.Moment = startDate.clone();

		while (now.isSameOrBefore(endDate)) {
			this.dates.push(now.format('YYYY-MM-DDTHH:mm:ss'));
			now.add(1, 'month');
		}

		const currentDate: string = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString();
		this.currentDate = this.dates.find(d => new Date(d).toISOString() === currentDate);
		this.form.get('effectiveStart').setValue(this.currentDate);
		return this.dates;
	}

	public chosenMonthHandler(normalizedMonth: moment.Moment): void {
		this.form.get('effectiveStart').patchValue(normalizedMonth);
	}

	public navigate(): void {
		this.router.navigate(['/pilotpay/aircraft-models']);
	}

	public toggleButtons(): void {
		this.cancel = true;
		if (this.id === '0') {
			this.saveNew = true;
		} else {
			this.saveChanges = true;
		}
	}

	public createNewAircraftModel(): void {
		this.aircraftModel.effectiveStart = this.form.value.effectiveStart;
		this.aircraftModel.name = this.form.value.name;

		this.aircraftModelsService.addAircraftModel(this.aircraftModel).subscribe(
			() => {
				this.navigate();
			},
			(error: HttpErrorResponse) => {}
		);
	}

	public deleteModel(): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.data = {
			modalType: 'delete',
			name: this.aircraftModel.name,
			modifiedDate: this.form.value.effectiveStart
		};

		if (this.dialog) {
			this.alertDialogRef = this.dialog.open(AlertDialogComponent, this.dialogConfig);
		}
		if (this.alertDialogRef) {
			this.alertDialogRef.beforeClosed().subscribe(() => {});
			this.alertDialogRef.afterClosed().subscribe((isDelete: boolean) => {
				if (isDelete) {
					const endDate: any = this.form.value.effectiveStart;
					this.aircraftModelsService.deleteAircraftModel(this.id, endDate).subscribe(
						() => {
							this.navigate();
						},
						(error: HttpErrorResponse) => {
							console.error(error);
						}
					);
				}
			});
		}
	}

	public getAircraftModel(id: string): void {
		this.aircraftModelsService.getAircraftModelById(id).subscribe(
			result => {
				this.aircraftModel = result;
				this.form.patchValue({ name: this.aircraftModel.name });
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public getArchivedAircraftModel(id: string): void {
		this.aircraftModelsService.getArchivedAircraftModelById(id).subscribe(
			result => {
				this.aircraftModel = result;
				this.form.patchValue({ name: this.aircraftModel.name });
				this.isArchived = true;
				this.form.controls['name'].disable();
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public saveChangesClicked(): void {
		this.aircraftModel.effectiveStart = this.form.value.effectiveStart;
		this.aircraftModel.name = this.form.value.name;

		this.aircraftModelsService.updateAircraftModel(this.aircraftModel).subscribe(
			() => {
				this.navigate();
			},
			(error: HttpErrorResponse) => {}
		);
	}
}
